export const doDeleteSite = async (objectid) => {
  try {
    const response = await fetch(`/sites/${objectid}`, {
      method: "DELETE",
      headers: { "Content-Type": "application/json" },
    });
    const data = await response.json();
    return response.ok ? { success: true } : { success: false, ...data };
  } catch (error) {
    return { success: false, function: "doDeleteSite", stack: error.message };
  }
};